import { type ComponentProps, type FC } from "react";
import { NotAdopted } from "@clientFrontend/features/entry/components/NotAdopted";
import { Heading } from "@root/shared/components/Heading";
import * as styles from "./styles.css";

export const EntryNotAdopted: FC<ComponentProps<typeof NotAdopted>> = ({
  notAdoptedContent,
  mailBodyParts,
  updateNotAdoptedPath,
  returnPagePath,
  recruitmentFeePath,
  gaLabel,
  isSp,
  isApp,
}) => {
  return (
    <div className={styles.article}>
      <Heading tag="h1" size="xLarge" bold className={styles.heading}>
        不採用報告
      </Heading>
      <NotAdopted
        notAdoptedContent={notAdoptedContent}
        mailBodyParts={mailBodyParts}
        updateNotAdoptedPath={updateNotAdoptedPath}
        returnPagePath={returnPagePath}
        recruitmentFeePath={recruitmentFeePath}
        gaLabel={gaLabel}
        isSp={isSp}
        isApp={isApp}
      />
    </div>
  );
};
